import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { maskPctBR } from "../../lib/numberFormat";

// R5 — extraído MECANICAMENTE de pages/NewOperation.jsx (JSX verbatim; o
// estado vive no componente-pai e chega por `ctx`).
export default function StepCedente({ ctx }) {
  const {
    cfg,
    cedentes,
    cedenteId,
    taxa,
    descricao,
    setDescricao,
    product,
    handleTaxaChange,
    handleCedenteChange,
  } = ctx;
  return (
    <div className="zemo-card p-6 space-y-5" data-testid="step-2-content">
      <div>
        <h2 className="text-lg font-semibold tracking-tight">Cedente e taxa</h2>
        <p className="text-sm text-zinc-500 mt-0.5">
          O valor e o prazo da operacao sao calculados a partir dos recebiveis (proxima etapa).
        </p>
      </div>
      <div className="grid sm:grid-cols-2 gap-5">
        <div className="space-y-1.5 sm:col-span-2">
          <Label className="text-[13px] font-medium">Cedente</Label>
          <Select value={cedenteId} onValueChange={handleCedenteChange}>
            <SelectTrigger className="h-11" data-testid="select-cedente">
              <SelectValue placeholder="Selecione um cedente..." />
            </SelectTrigger>
            <SelectContent>
              {cedentes.map((c) => (
                <SelectItem key={c.id} value={c.id}>
                  <div className="flex flex-col">
                    <span className="font-medium">{c.razao_social}</span>
                    <span className="text-[11px] text-zinc-500 font-mono-num">{c.cnpj}</span>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        {cfg.showRates && (
          <div className="space-y-1.5">
            <Label className="text-[13px] font-medium">Taxa mensal (%) — opcional</Label>
            <Input type="text" inputMode="decimal" value={taxa} onChange={(e) => handleTaxaChange(maskPctBR(e.target.value, taxa))} placeholder={product ? `${product.taxa_min}-${product.taxa_max}%` : "0,00"} className="h-11 font-mono-num" data-testid="input-taxa" />
            <p className="text-[12px] text-zinc-400">Em branco, vale a taxa da policy configurada na V2.</p>
          </div>
        )}
        <div className="space-y-1.5 sm:col-span-2">
          <Label className="text-[13px] font-medium">Descricao (opcional)</Label>
          <Textarea value={descricao} onChange={(e) => setDescricao(e.target.value)} placeholder="Notas internas, observacoes..." rows={3} data-testid="input-descricao" />
        </div>
      </div>
    </div>
  );
}
